import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { LogisticAction, ErrorAction } from "redux/actions";
import { UTILS } from "utils";
import { logToSentry } from "utils/Utils";
import {
  useGetOrderInfoByIdMutation,
} from "redux/Logistic/LogisticService";
import { API } from "api";

import Modal from "components/Modal";
import OrderButton from "./components/Button";
import CareemNOW from "./careem-now/CareemNow";
import Jeebly from "./jeebly/Jeebly";
import IFast from "./ifast/ifast";
import Slider from "./slider/Slider";   
import { INTEGRATION_NAMES } from "./constants";
import LogisticModalSelector from "./LogisticModalSelector";

function SelectedLogistics({ onDeliveryAction }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [openType, setopenType] = useState(null);
  const [showSliderButton, setShowSliderButton] = useState(false);
  const [selectedDelivery, setSelectedDelivery] = useState(null);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const { changeDeliveryModal, orderInfo: order } = useSelector(
    (state) => state.LogisticReducer
  );
  const [getOrderInfoById] = useGetOrderInfoByIdMutation();

  /**
   * It checks if the order has an active integration with the name passed in the parameter.
   * @param name - The name of the integration.
   * @returns isIntegrationDialogOpen
   */

  const isInterated = (name) => {
    let isIntegrationDialogOpen = false;
    if (order && UTILS.isValidObject(["activeIntegrations"], order)) {
      if (Array.isArray(order.activeIntegrations)) {
        for (let index = 0; index < order?.activeIntegrations.length; index++) {
          const element = order?.activeIntegrations[index];
          if (
            element?.name === name &&
            element?.category === "LOGISTIC" &&
            element?.isActive === true
          ) {
            isIntegrationDialogOpen = true;
          }
        }
      }
    }
    return isIntegrationDialogOpen;
  };

  const isSelected = (odr) => {
    const selectedDelivery = UTILS.getSelectedDelivery(odr);
    setSelectedIntegration(selectedDelivery);
    return selectedDelivery;
  };
  useEffect(() => {
    setSelectedIntegration(isSelected(order));
  }, [order]);


  const checkIfDeliverySelected = (deliveryType) => {
    onDeliveryAction?.();
    // Get the currently selected delivery type
    // If no delivery type has been selected
    if (selectedIntegration === INTEGRATION_NAMES.STORE) {
      // Check which delivery type the user wants to use
      if (deliveryType === INTEGRATION_NAMES.CAREEM_NOW) {
        dispatch(LogisticAction.toggleCareemModal(true));
      } else if (deliveryType === INTEGRATION_NAMES.JEEBLY) {
        dispatch(LogisticAction.toggleJeeblyModal(true));
      } else if (deliveryType === INTEGRATION_NAMES.SLIDER) {
        dispatch(LogisticAction.toggleSliderModal(true));
      }else if (deliveryType === INTEGRATION_NAMES.SLIDER) {
        dispatch(LogisticAction.toggleSliderModal(true));
      }else if (deliveryType === INTEGRATION_NAMES.IFAST) {
        dispatch(LogisticAction.toggleIfastModal(true));
      } else {
        logToSentry("User wants to use an unknown logistic type.");
      }
    }

    // If the user wants to check information about the selected delivery type
    if (
      selectedIntegration !== INTEGRATION_NAMES.STORE &&
      selectedIntegration === deliveryType
    ) {
      // Check which delivery type the user wants to view information about
      if (deliveryType === INTEGRATION_NAMES.CAREEM_NOW) {
        dispatch(LogisticAction.toggleCareemModal(true));
      } else if (deliveryType === INTEGRATION_NAMES.JEEBLY) {
        dispatch(LogisticAction.toggleJeeblyModal(true));
      } else if (deliveryType === INTEGRATION_NAMES.SLIDER) {
        dispatch(LogisticAction.toggleSliderModal(true));
      }else if (deliveryType === INTEGRATION_NAMES.IFAST) {
        dispatch(LogisticAction.toggleIfastModal(true));
      } else {
        logToSentry(
          "User wants to view information about an unknown logistic type."
        );
      }
    }

    // If the user wants to change the delivery type
    if (
      selectedIntegration !== INTEGRATION_NAMES.STORE &&
      selectedIntegration !== deliveryType
    ) {
      setSelectedDelivery(selectedDelivery);
      dispatch(LogisticAction.toggleDeliveryModal(true));
      if (deliveryType === INTEGRATION_NAMES.CAREEM_NOW) {
        setopenType(INTEGRATION_NAMES.CAREEM_NOW);
      } else if (deliveryType === INTEGRATION_NAMES.JEEBLY) {
        setopenType(INTEGRATION_NAMES.JEEBLY);
      }else if (deliveryType === INTEGRATION_NAMES.SLIDER) {
        setopenType(INTEGRATION_NAMES.SLIDER);
      }else if (deliveryType === INTEGRATION_NAMES.IFAST) {
        setopenType(INTEGRATION_NAMES.IFAST);
      } else {
        logToSentry("User wants to change to an unknown logistic type.");
      }
    }
  };

  function shouldRenderCareemButton(order) {
    return order && isInterated(INTEGRATION_NAMES.CAREEM_NOW);
  }

  function shouldRenderJeeblyButton(order) {
    return order && isInterated(INTEGRATION_NAMES.JEEBLY);
  }

  function shouldRenderIfastButton(order) {
    return order && isInterated(INTEGRATION_NAMES.IFAST);
  }

  async function shouldRenderSliderButton(order) {
    try{
      const isCheckForActiveStore = order && isInterated(INTEGRATION_NAMES.SLIDER);
      if(!isCheckForActiveStore) return;
      const isSliderEnableForStore = await API.IS_SLIDER_ENABLE_FOR_STORE({
        storeId: order?.storeId,
      });
      // return isSliderEnableForStore?.data?.canDeliver;
      setShowSliderButton(isSliderEnableForStore?.data?.canDeliver);
    } catch (error) {
      return
    }
  }

  const fetchOrderDetailsByID = async () => {
    try {
      const userDetail = UTILS.getCurrentUser();
      if (order?._id && userDetail.brandId) {
        const { data } = await getOrderInfoById({
          orderId: order._id,
          brandId: userDetail.brandId,
        });
        return data;
      }
    } catch (error) {
      dispatch(
        ErrorAction.setError("Something went wrong while fetching order info")
      );
    }
  };

  useEffect(() => {

    if (order) {
      shouldRenderSliderButton(order)
    }
  }, [order]);

  return (
    <>
      {/* CAREEM BUTTON */}
      {shouldRenderCareemButton(order) && (
        <OrderButton
          deliveyType={INTEGRATION_NAMES.CAREEM_NOW}
          btnText={t("Deliver using Careem")}
          handleDelivery={checkIfDeliverySelected}
          order={order}
        />
      )}
      <CareemNOW {...{ order, fetchOrderDetailsByID }} />

      {/* JEEBLY BUTTON */}
      {shouldRenderJeeblyButton(order) && (
        <OrderButton
          deliveyType={INTEGRATION_NAMES.JEEBLY}
          btnText={t("Deliver using Jeebly")}
          handleDelivery={checkIfDeliverySelected}
          order={order}
        />
      )}
      <Jeebly {...{ order, fetchOrderDetailsByID }} />

      {shouldRenderIfastButton(order) && (
        <OrderButton
          deliveyType={INTEGRATION_NAMES.IFAST}
          btnText={t("Deliver using IFast")}
          handleDelivery={checkIfDeliverySelected}
          order={order}
        /> 
      )}
      <IFast {...{ order, fetchOrderDetailsByID }} />


      {/* SLIDER BUTTON */}
      
      {showSliderButton &&
        <OrderButton
          deliveyType={INTEGRATION_NAMES.SLIDER}
          btnText={t("Deliver using Slider")}
          handleDelivery={checkIfDeliverySelected}
          order={order}
        />
      }
      <Slider {...{ order, fetchOrderDetailsByID }} />
      

      {/* MODAL TO CHECK IF ANY DELIVERY METHOD IS ALREADY ATTACHED TO  THIS ORDER */}
      <Modal
        modalType="redux"
        open={changeDeliveryModal}
        modalWidth="rounded-md border border-gray-300 top-0 w-full md:w-1/2"
        onClose={LogisticAction.toggleDeliveryModal}
      >
        {/* <OrderDeliveryCheckModal /> */}
        <LogisticModalSelector
          {...{ order, openType, selectedIntegration, isSelected }}
        />
      </Modal>
    </>
  );
}

export default SelectedLogistics;
